// useActionSheet.js
import { ref, createVNode, render } from "vue"
import MyActionSheet from "./index.jsx"

export default function showActionSheet(options) {
  const { title, actions } = options

  const container = document.createElement("div")
  document.body.appendChild(container)

  const vnode = createVNode(MyActionSheet, {
    title,
    actions,
    visible: true,
    onSelect: (action) => {
      options.onSelect?.(action)
      // 选择后也移除 DOM 节点
      render(null, container)
      document.body.removeChild(container)
    },
    onClose: () => {
      // 关闭时移除 DOM 节点
      setTimeout(() => {
        render(null, container)
        document.body.removeChild(container)
      }, 300)
    }
  })

  // 渲染 vnode 到容器中
  render(vnode, container)
}
